module.exports = __webpack_public_path__ + "img/microneedling-treatment-desktop-en.daf6e20b.jpg";